import React from 'react'
import styled from 'styled-components'

const Footer = styled.div`
  background-color: white;
  height: 50px;
  line-height: 50px;
  color: #999;
  .footer-items {
    margin-left: auto;
    max-width: 500px;
    display: flex;
    justify-content: space-around;
    .item {
      min-width: 30%;
      text-align: center;
      cursor: pointer;
      transition: color 0.2s;
      &:hover {
        color: black;
      }
    }
  }
  @media screen and (max-width: 850px) {
    height: auto;
    .footer-items {
      line-height: 40px;
      display: block;
      max-width: none;
      .item:nth-child(2) {
        background: #f5f5f5;
      }
    }
  }
`

const _Footer = () => (
  <Footer>
    <div className="footer-items">
      <div className="item">
        <a href="https://www.monbanquet.fr">© Monbanquet.fr</a>
      </div>
      <div className="item">
        <a href="https://www.monbanquet.fr/cgv">CGV</a>
      </div>
      <div className="item">
        <a href="https://www.monbanquet.fr/mentions-legales">
          Mentions légales
        </a>
      </div>
    </div>
  </Footer>
)

export default _Footer



// WEBPACK FOOTER //
// ./src/components/Footer.js